import React from "react"

function IconAvatarStatus({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="avatar-status"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-avatar-status"
      {...props}
    >
      <path
        d="M12.11 3.71A8.51 8.51 0 0 1 20.36 14.3a4.36 4.36 0 0 0-1.166-.8 7.2 7.2 0 1 0-12.723 3.196 2.18 2.18 0 0 1 1.463-1.38l1.473-.418a3.577 3.577 0 0 1-1.047-2.526v-2.195c0-2.012 1.677-3.642 3.745-3.642 2.069 0 3.746 1.63 3.746 3.642v2.195c0 .325-.044.64-.126.94l-.031.101a4.378 4.378 0 0 0-2.4 2.412l.027-.008c-.32.107-.658.173-1.01.191l-.206.006a3.84 3.84 0 0 1-1.183-.186l-2.63.747a.873.873 0 0 0-.627.724l-.007.115v.463a7.17 7.17 0 0 0 4.45 1.54c.438 0 .866-.039 1.282-.114.203.432.475.826.801 1.167A8.51 8.51 0 1 1 12.11 3.709zm5.235 10.835a2.91 2.91 0 1 1 0 5.819 2.91 2.91 0 0 1 0-5.819zm0 1.31a1.6 1.6 0 1 0 0 3.2 1.6 1.6 0 0 0 0-3.2zm-5.239-8.01c-1.295 0-2.341.963-2.43 2.167l-.006.166v2.195c0 .918.557 1.72 1.36 2.1l.19.079.169.057.197.047.14.025.175.019.171.006.171-.004.25-.025.13-.025.2-.049.177-.06.249-.109c.725-.369 1.227-1.078 1.288-1.895l.006-.166v-2.195c0-1.28-1.083-2.333-2.437-2.333z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconAvatarStatus
